module.exports = __webpack_public_path__ + "img/b9c4afe.jpg";